import React from "react";
import ContactForm from "../components/contact/ContactForm";
import Banner from "../components/comman/Banner";
const Contact = () => {
    return (
        <div>
            <Banner title="Contact" />
            <ContactForm />
        </div>
    );
}

export default Contact;
